import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/media/images/logo_v1.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-2c85bae6")

_pushScopeId("data-v-2c85bae6")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "subscription-holder"
}
const _hoisted_3 = { class: "subscription-main" }
const _hoisted_4 = { class: "subscription-widget card mb-10" }
const _hoisted_5 = { class: "card-p" }
const _hoisted_6 = { class: "details-header" }
const _hoisted_7 = { class: "fs-3" }
const _hoisted_8 = { class: "column-holder" }
const _hoisted_9 = { class: "column" }
const _hoisted_10 = { class: "details-list" }
const _hoisted_11 = { class: "text-color-default" }
const _hoisted_12 = { class: "text-color-default" }
const _hoisted_13 = { class: "text-color-default" }
const _hoisted_14 = { class: "text-color-default" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "text-color-default" }
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "text-color-default" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "text-color-default" }
const _hoisted_24 = { class: "text-color-default" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "text-color-default" }
const _hoisted_28 = { class: "payment-method-row" }
const _hoisted_29 = { class: "text-color-default" }
const _hoisted_30 = { class: "payment-method-controls" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "text-color-default" }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "text-color-default" }
const _hoisted_35 = { class: "subscription-widget card mb-10" }
const _hoisted_36 = { class: "subscribed-product-details" }
const _hoisted_37 = { class: "card-header card-p border-0" }
const _hoisted_38 = { class: "card-title align-items-start flex-column" }
const _hoisted_39 = { class: "card-label fw-bolder fs-3" }
const _hoisted_40 = { class: "image-holder" }
const _hoisted_41 = {
  key: 1,
  src: _imports_0,
  alt: "product image"
}
const _hoisted_42 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_43 = { class: "product-info" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("(")
const _hoisted_45 = /*#__PURE__*/_createVNode("span", { class: "product-no-label" }, "Product no : ", -1)
const _hoisted_46 = { class: "text-end" }
const _hoisted_47 = { class: "text-end" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = {
  key: 0,
  class: "action-btn",
  type: "button",
  id: "action-trigger",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_51 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_52 = {
  key: 1,
  class: "dropdown-menu dropdown-menu-end action-dropdown",
  "aria-labelledby": "action-trigger"
}
const _hoisted_53 = { class: "menu-item-wrapper" }
const _hoisted_54 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_55 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)
const _hoisted_56 = { class: "total-subscription-cost text-end" }
const _hoisted_57 = { class: "text-color-default" }
const _hoisted_58 = { class: "card" }
const _hoisted_59 = { class: "card-header card-p border-0" }
const _hoisted_60 = { class: "card-title align-items-start flex-column" }
const _hoisted_61 = { class: "card-label fw-bolder fs-3" }
const _hoisted_62 = { class: "card-body p-0" }
const _hoisted_63 = { class: "table-responsive" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_66 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_67 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_68 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_69 = /*#__PURE__*/_createVNode("button", {
  class: "action-btn",
  type: "button",
  id: "action-trigger",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" })
], -1)
const _hoisted_70 = {
  class: "dropdown-menu dropdown-menu-end action-dropdown",
  "aria-labelledby": "action-trigger"
}
const _hoisted_71 = { class: "menu-item-wrapper" }
const _hoisted_72 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_73 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-clipboard-list" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SubscriptionLoader = _resolveComponent("SubscriptionLoader")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_Table = _resolveComponent("Table")!
  const _component_SubscriptionProducts = _resolveComponent("SubscriptionProducts")!
  const _component_FrequencyChanging = _resolveComponent("FrequencyChanging")!

  return (_ctx.loader)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_SubscriptionLoader)
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t('message.SUBSCRIPTION_DETAILS')), 1)
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("ul", _hoisted_10, [
                    _createVNode("li", null, [
                      _createVNode("strong", _hoisted_11, _toDisplayString(_ctx.$t('message.BILL_TO')) + ":", 1),
                      _createVNode("span", null, _toDisplayString(_ctx.subscribeData?.order_subscription?.customer?.user?.email), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", _hoisted_12, _toDisplayString(`${_ctx.$t('message.CUSTOMER_NAME')}`) + ":", 1),
                      _createVNode("span", null, _toDisplayString(_ctx.subscribeData?.order_subscription?.customer?.user?.name), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", _hoisted_13, _toDisplayString(_ctx.$t('message.ADDRESS')) + ":", 1),
                      _createVNode("span", null, _toDisplayString(_ctx.customerAddress), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", _hoisted_14, _toDisplayString(_ctx.$t('message.PHONE_NUMBER')) + ":", 1),
                      _createVNode("span", null, _toDisplayString(_ctx.subscribeData?.order_subscription?.customer?.phone_number), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("span", _hoisted_15, [
                        _createVNode("strong", _hoisted_16, _toDisplayString(`${_ctx.$t('message.SUBSCRIPTION_PRODUCT')}`) + ":", 1),
                        (_ctx.subscribeData?.order_subscription?.status)
                          ? (_openBlock(), _createBlock("span", {
                              key: 0,
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showFrequencyModal && _ctx.showFrequencyModal(...args))),
                              class: "ms-2 svg-icon svg-icon-3 mb-4"
                            }, [
                              _hoisted_17
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.subscribeData?.order_subscription?.tenure)
                        ? (_openBlock(), _createBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('message.' + _ctx.subscribeData?.order_subscription?.tenure)), 1))
                        : (_openBlock(), _createBlock("span", _hoisted_19, "N/A"))
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", _hoisted_20, _toDisplayString(`${_ctx.$t('message.SUBSCRIPTION_ID')}`) + ":", 1),
                      (_ctx.subscribeData?.order_subscription?.id)
                        ? (_openBlock(), _createBlock("span", _hoisted_21, _toDisplayString(_ctx.subscribeData?.order_subscription?.id), 1))
                        : (_openBlock(), _createBlock("span", _hoisted_22, "N/A"))
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", _hoisted_23, _toDisplayString(_ctx.$t('message.STARTED_DATE')) + ":", 1),
                      _createVNode("span", null, _toDisplayString(_ctx.subscribeData?.order_subscription?.initial_order_date), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", _hoisted_24, _toDisplayString(_ctx.$t('message.STATUS')) + ":", 1),
                      (_ctx.subscribeData?.order_subscription?.status == 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('message.ACTIVE')), 1))
                        : (_openBlock(), _createBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('message.INACTIVE')), 1))
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", _hoisted_27, _toDisplayString(_ctx.$t('message.NEXT_INVOICE')) + ":", 1),
                      _createVNode("span", null, _toDisplayString(_ctx.subscribeData?.order_subscription?.next_order_date), 1)
                    ]),
                    _createVNode("li", _hoisted_28, [
                      _createVNode("strong", _hoisted_29, _toDisplayString(_ctx.$t('message.PAYMENT_METHOD')) + ":", 1),
                      _createVNode("div", _hoisted_30, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.selectedPaymentMethodId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedPaymentMethodId = $event)),
                          class: "payment-method-select",
                          placeholder: _ctx.$t('message.SELECT'),
                          loading: _ctx.paymentMethodsLoading,
                          filterable: "",
                          onChange: _ctx.onPaymentMethodChange
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paymentMethodOptions, (pm) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: pm.value,
                                label: pm.label,
                                value: pm.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder", "loading", "onChange"])
                      ])
                    ]),
                    (_ctx.showEanInfo)
                      ? (_openBlock(), _createBlock("li", _hoisted_31, [
                          _createVNode("strong", _hoisted_32, _toDisplayString(_ctx.$t('message.CONTACT_PERSON')) + ":", 1),
                          _createVNode("span", null, _toDisplayString(_ctx.displayEanContactPerson || 'N/A'), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.showEanInfo)
                      ? (_openBlock(), _createBlock("li", _hoisted_33, [
                          _createVNode("strong", _hoisted_34, _toDisplayString(_ctx.$t('message.EAN')) + ":", 1),
                          _createVNode("span", null, _toDisplayString(_ctx.displayEanNumber || 'N/A'), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_35, [
            _createVNode("div", _hoisted_36, [
              _createVNode("div", _hoisted_37, [
                _createVNode("h3", _hoisted_38, [
                  _createVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('message.SUBSCRIBED_PRODUCTS')), 1)
                ])
              ]),
              _createVNode(_component_Table, {
                columns: _ctx.columns,
                rows: _ctx.subscribeData?.order_products,
                padding: 5
              }, {
                "cell-image": _withId(({ row: item }) => [
                  _createVNode("div", _hoisted_40, [
                    (item?.file_path)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          src: item?.file_path,
                          alt: "product image"
                        }, null, 8, ["src"]))
                      : (_openBlock(), _createBlock("img", _hoisted_41))
                  ])
                ]),
                "cell-name": _withId(({ row: item }) => [
                  _createVNode("span", null, _toDisplayString(item?.product_name), 1),
                  _hoisted_42,
                  _createVNode("span", _hoisted_43, [
                    _hoisted_44,
                    _hoisted_45,
                    _createTextVNode(_toDisplayString(item?.remote_id) + ")", 1)
                  ])
                ]),
                "cell-price": _withId(({ row: item }) => [
                  _createVNode("div", _hoisted_46, _toDisplayString(item?.discounted_price || item?.price), 1)
                ]),
                "cell-total": _withId(({ row: item }) => [
                  _createVNode("div", _hoisted_47, _toDisplayString(item?.total), 1)
                ]),
                "cell-quantity": _withId(({ row: item }) => [
                  (item?.multiple_limit == null && item?.multiples == null)
                    ? (_openBlock(), _createBlock("div", _hoisted_48, [
                        _createVNode(_component_el_input_number, {
                          disabled: item?.discount_type != 'SUBSCRIPTION_DISCOUNT' ? false : true,
                          modelValue: item.quantity,
                          "onUpdate:modelValue": ($event: any) => (item.quantity = $event),
                          min: 1,
                          onChange: ($event: any) => (_ctx.handleChange(item?.quantity, item?.product_id, item?.order_subscription_id))
                        }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_49, [
                        _createVNode(_component_el_select, {
                          modelValue: item.quantity,
                          "onUpdate:modelValue": ($event: any) => (item.quantity = $event),
                          onFocus: ($event: any) => (_ctx.cartLimit(item?.multiple_limit, item?.multiples)),
                          size: "small",
                          disabled: item?.discount_type != 'SUBSCRIPTION_DISCOUNT' ? false : true,
                          placeholder: "Select",
                          onChange: ($event: any) => (_ctx.handleChange(item?.quantity, item?.product_id, item?.order_subscription_id)),
                          class: "theme-select"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cartLimits, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item,
                                label: item,
                                value: item
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "onFocus", "disabled", "onChange"])
                      ]))
                ]),
                "cell-actions": _withId(({ row: item }) => [
                  (item?.discount_type != 'SUBSCRIPTION_DISCOUNT')
                    ? (_openBlock(), _createBlock("button", _hoisted_50, [
                        _hoisted_51
                      ]))
                    : _createCommentVNode("", true),
                  (item?.discount_type != 'SUBSCRIPTION_DISCOUNT')
                    ? (_openBlock(), _createBlock("div", _hoisted_52, [
                        _createVNode("div", _hoisted_53, [
                          (_ctx.$can('delete_price_group'))
                            ? (_openBlock(), _createBlock("div", _hoisted_54, [
                                _createVNode("a", {
                                  onClick: ($event: any) => (_ctx.handleSubscriptionDelete(item)),
                                  class: "menu-link me-1"
                                }, [
                                  _hoisted_55,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('message.DELETE')), 1)
                                ], 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["columns", "rows"]),
              _createVNode("div", _hoisted_56, [
                _createVNode("strong", _hoisted_57, _toDisplayString(_ctx.subscribeData?.order_subscription?.product_total), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_58, [
            _createVNode("div", _hoisted_59, [
              _createVNode("h3", _hoisted_60, [
                _createVNode("span", _hoisted_61, _toDisplayString(`${_ctx.$t('message.LATEST_ORDERS')}`), 1)
              ])
            ]),
            _createVNode("div", _hoisted_62, [
              _createVNode("div", _hoisted_63, [
                _createVNode(_component_Table, {
                  columns: _ctx.columns_order,
                  rows: _ctx.subscribeData?.order_subscription?.order_subscription_history,
                  padding: 5
                }, {
                  "cell-id": _withId(({ row: item }) => [
                    _createTextVNode(_toDisplayString(item?.current_order?.id), 1)
                  ]),
                  "cell-status": _withId(({ row: item }) => [
                    (item?.current_order?.order_status?.status)
                      ? (_openBlock(), _createBlock("span", _hoisted_64, _toDisplayString(item?.current_order?.order_status?.status), 1))
                      : _createCommentVNode("", true)
                  ]),
                  "cell-economic": _withId(({ row: item }) => [
                    (item?.current_order?.economic_order_id != null)
                      ? (_openBlock(), _createBlock("span", _hoisted_65, _toDisplayString(_ctx.$t('message.SENT')), 1))
                      : (_openBlock(), _createBlock("span", _hoisted_66, _toDisplayString(_ctx.$t('message.NOT_SENT')), 1))
                  ]),
                  "cell-shipment_status": _withId(({ row: item }) => [
                    (item?.current_order?.order_status_id == 6)
                      ? (_openBlock(), _createBlock("span", _hoisted_67, _toDisplayString(_ctx.$t('message.SENT')), 1))
                      : (_openBlock(), _createBlock("span", _hoisted_68, _toDisplayString(_ctx.$t('message.NOT_SENT')), 1))
                  ]),
                  "cell-actions": _withId(({ row: item }) => [
                    _hoisted_69,
                    _createVNode("div", _hoisted_70, [
                      _createVNode("div", _hoisted_71, [
                        (_ctx.$can('view_order_detail'))
                          ? (_openBlock(), _createBlock("div", _hoisted_72, [
                              _createVNode("a", {
                                onClick: ($event: any) => (_ctx.handleView(item)),
                                class: "menu-link me-1"
                              }, [
                                _hoisted_73,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('message.VIEW')), 1)
                              ], 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["columns", "rows"])
              ])
            ])
          ])
        ]),
        _createVNode(_component_SubscriptionProducts, { ref: "productLists" }, null, 512),
        _createVNode(_component_FrequencyChanging, {
          onFrequencyUpdated: _ctx.handleFrequencyUpdated,
          ref: "frequencyModal"
        }, null, 8, ["onFrequencyUpdated"])
      ]))
})